<!-- static content data from lang: question -->
<template>
  <div>
    <div class="h-100" v-loading="loading">
    <base-header class="pb-6">
      <div class="row align-items-center pb-4">
        <div class="col-lg-12 col-12">
          <h6 class="h2 text-white d-inline-block mb-0">{{lang.label.AddheaderTitle}}</h6>
          <nav aria-label="breadcrumb" class="d-inline-block ml-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card class="no-border-card mb-0" body-classes="px-0 pb-1" footer-classes="pb-2">
          <div class="col-md-12">
            <template v-for="(message) in alertMessages">
              <Alert :type = alertType dismissible  v-if="message">  <span class="alert-inner--text">{{message}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
            </template>
            <template v-for="(message) in successMessages">
              <Alert :type = successType dismissible  v-if="message">  <span class="alert-inner--text">{{message}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
            </template>
            <validation-observer v-slot="{handleSubmit}" ref="formValidator">
              <form role="form" @submit.prevent="handleSubmit(onSubmit)">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="row">
                      <div class="col-md-12">
                        <base-input
                          :label="lang.label.code"
                          name="code"
                          :rules="{required: true}"
                          v-model="model.code"
                          autocomplete="off"
                          labelClasses="form-control-label asterisk-mark"
                        ></base-input>
                      </div>
                      <div class="col-md-12">
                       <base-input
                          :label="lang.label.queastion"
                          name="question"
                          :rules="{required: true}"

                          labelClasses="form-control-label asterisk-mark"
                        >
                        <html-editor  v-model="model.name" autocomplete="off"> </html-editor>
                        </base-input>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="text-right mb-3">
                  <base-button type="primary" native-type="submit">{{lang.label.buttons.save}}</base-button>
                  <base-button
                    type="danger"
                    @click="$router.push({name: 'question'})"
                  >{{lang.label.buttons.cancel}}</base-button>
                </div>
              </form>
            </validation-observer>
          </div>
        </card>
      </div>
    </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import HtmlEditor from '@/components/Inputs/HtmlEditor'
import Alert from "@/components/BaseAlert.vue";
// import {mapGetters} from "vuex";
export default {
  components: {
    RouteBreadCrumb,HtmlEditor,
    Alert
  },
  data() {
    return {
      lang: this.$lang.question,
      loading: false,
      model: {
        code: "",
        name: ""
      },
        alertType: 'danger',
        successType: 'success',
        alertMessages: [],
        successMessages: [],
    };
  },
  // computed:{
  //      ...mapGetters({
  //             login: "login",
  //             loading: "loading",
  //      }),
  // },
  // mounted(){
  //     this.$store.commit('setLoading', true);
  //     this.$store.dispatch('deviceList').then(response => {
  //         this.companyName = response;
  //            let selectedDetails =  this.companyName.filter(c => {
  //                                 return c.ID == this.$route.id;
  //                               });
  //             this.model.companyName = selectedDetails[0].Name;
  //             this.model.siteName = selectedDetails[0].CompanySiteName;

  //     });
  // },
  methods: {
    onSubmit() {
      this.loading = true;
      let self = this;
       let data = {
                "Code" :this.model.code,
               "Name":this.model.name ,
            };
            this.$store.dispatch('createQuestion', data)
                    .then(response => {
                     if (response.status == 200) {
                      this.model.code='';
                      this.model.name = '';
                       this.flash({message: response.data.message, variant: 'success'});
                        this.$router.push({ name: "question" });
                        this.loading = false;
                     }else{
                         if(typeof response.data.message != 'object'){
                             this.alertMessages.push(response.data.message);
                         }else{
                             let array = new Array();
                             for (let key of Object.keys(response.data.message)) {
                                 let obj = response.data.message[key][0].includes('field') ? (key+"- "+response.data.message[key][0]) : response.data.message[key];
                                 array.push(obj)
                             }
                             this.alertMessages.push(array.join(', '));
                             setTimeout(function () {
                                 self.alertMessages = [];
                             },5000)
                         }
                         this.loading = false;
                      }
                    }).catch(error => {
                        this.loading = false;
                    })
    }
  }
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
.modal-header {
  padding-bottom: 0;
}
</style>
